export const incoseSlides = [
  {
    title: "Regla N.° 1",
    text: "Utilizá oraciones estructuradas y completas (sujeto, verbo, objeto)."
  },
  {
    title: "Regla N.° 2",
    text: "Empleá la voz activa, indicando claramente la entidad responsable (sujeto) en cada requerimiento."
  },
  {
    title: "Regla N.° 6",
    text: "Cada número debe estar acompañado de su unidad de medida física."
  },
  {
    title: "Regla N.° 7",
    text: "Evitá términos vagos como “algunos”, “varios”, “muchos”, “aprox.”, “casi siempre”, “cercano a”, etc."
  },
  {
    title: "Regla N.° 8",
    text: "Evitá cláusulas de escape como “en la medida de lo posible”, “si fuera necesario”, “cuando sea posible” o similares."
  },
  {
    title: "Regla N.° 9",
    text: "No uses cláusulas abiertas como “etc.”, “entre otros” o “y así sucesivamente”. Sé explícito."
  },
  {
    title: "Regla N.° 10",
    text: "Evitá infinitivos superfluos como “ser capaz de”, “poder”, “diseñado para” si no aportan valor real."
  },
  {
    title: "Regla N.° 13",
    text: "Utilizá una ortografía correcta"
  },
  {
    title: "Regla N.° 17",
    text: "No utilices el caracter '/' excepto para separar unidades de medida."
  },
  {
    title: "Regla N.° 19",
    text: "Evitá combinar múltiples cláusulas con “y”, “o”, “pero”, “además de”, “sin embargo”, etc."
  },
  {
    title: "Regla N.° 24",
    text: "Evitá pronombres e indefinidos. Usa sustantivos concretos para no generar ambigüedad."
  },
  {
    title: "Regla N.° 26",
    text: "No emplees absolutos inalcanzables como 100% de confiabilidad o disponibilidad, “siempre”, “nunca”, etc."
  },
  {
    title: "Regla N.° 32",
    text: "Empleá “cada” en lugar de “todos” o “cualquier” al referirte a universalidad, para mayor precisión."
  },
  {
    title: "Regla N.° 35",
    text: "Expresá las dependencias temporales de forma explícita en lugar de usar palabras indefinidas como “antes de”, “luego de”, “simultáneamente”, etc."
  },
  {
    title: "Regla N.° 41",
    text: "Definí una estructura para la escritura de los requerimientos (ver instrucciones)"
  }
];
  